import { Component } from '@angular/core';
import { Login } from '../models/loginmodel';

// * import the name of service we have created
import { loginService }   from '../services/login.service';
import { SharedService }   from '../services/sharedservices.service';
import { PaymentResponse } from '../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
@Component({
  selector: 'app-root',
  //templateUrl: './dashboard/dashboard.component.html',
  //styleUrls: ['../css/sb-admin.min.css'],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [loginService]
})

export class AppComponent {
  
  public isAdmin = false;

    constructor(fb: FormBuilder,private _LoginService: loginService, public router: Router, private sharedservice: SharedService) {
      //navigation link.
         
     /* if (this.sharedservice.session != null)
      {
        if (this.sharedservice.session.account_status == "1")
          this.router.navigate(['mca']);
        if(this.sharedservice.session.account_role == "admin"){
          this.isAdmin = true;
        }
      }
      this.router.navigate(['login']); */

    }
   
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/app.component.ts